import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { fadeIn, fadeOut } from 'src/app/animations';
import { GlobalSettingsService } from "src/app/services/ui/global-settings.service";
import { ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/services/sections/shared/user.service";
import { TokenHelper } from "src/app/services/helpers/token.helper";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
	selector: 'delete-user-account',
	templateUrl: './delete-user-account.component.html',
	styleUrls: ['./delete-user-account.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss', '../../stylesheets/forms-container.scss'],
	animations: [fadeIn(200), fadeOut(200)]
})
export class DeleteUserAccountComponent implements OnInit, OnDestroy {
	userInfo: any = {};
	deleteInput = "";
	isDeleteSucceeded = false;
	isDeleteFailed = false;
	isSaving = false;

	private unsubscriber$: Subject<void> = new Subject<void>();

	constructor(
		private activatedRoute: ActivatedRoute,
		private userService: UserService
	) { }

	ngOnInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
		this.userInfo = this.activatedRoute.snapshot.data.user;

		localStorage.removeItem('rurl');
		localStorage.removeItem('platform_type_id');
	}

	onDelete() {
		if (this.deleteInput === "delete") {
			this.isSaving = true;
			this.userService
				.deleteUserAccount(TokenHelper.getToken(this.activatedRoute))
				.pipe(
					takeUntil(this.unsubscriber$)
				)
				.subscribe(
					result => {
						if (result) {
							this.isDeleteSucceeded = true;
						}
						else {
							this.isDeleteFailed = true;
						}
						this.isSaving = false;
					},
					() => {
						this.isDeleteFailed = true;
						this.isSaving = false;
					}
				)
		}
	}

	ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}
}